/*@ngInject*/
const AttachmentMediator = function (attachmentRepository, saveAttachmentRepository,
                                              updateAttachmentRepository, deleteAttachmentRepository,
                                              attachmentEmailsRepository) {

    this.retrieveAttachment = function (attachmentId) {
        return attachmentRepository.retrieveAttachment(attachmentId);
    };

    this.saveAttachment = function (data, file) {
        return saveAttachmentRepository.saveAttachment(data, file);
    };

    this.updateAttachment = function (attachmentId, attachment) {
        return updateAttachmentRepository.updateAttachment(attachmentId, attachment);
    };

    this.deleteAttachment = function (attachmentId, fieldId) {
        return deleteAttachmentRepository.deleteAttachment(attachmentId, fieldId);
    };

    this.retrieveAttachmentEmails = function (attachmentId) {
        return attachmentEmailsRepository.retrieveAttachmentEmails(attachmentId);
    };

};

angular.module('umCore').service('attachmentMediator', AttachmentMediator);
